import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SubscriptionService } from 'src/app/modules/subscription/services/subscription.service';

@Component({
  selector: 'app-number-modal',
  templateUrl: './number-modal.component.html',
  styleUrls: ['./number-modal.component.css'],
})
export class NumberModalComponent implements OnInit {
  title: any
  constructor(private dialog: MatDialog, private mapService: MapServiceService,private subscriptionService: SubscriptionService,
    ) {
    //modal to show that numbers are allowed only
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.title = this.subscriptionService.getAllModals.number_allowed

    }, 1000);
  }

  close(): void {
    this.dialog.closeAll();
  }
}
